import axios from 'axios';

export default {
  getRecords(path, params = {}) {
    return axios.get(`${path}`, { params }).then((response) => {
      return response.data;
    });
  },

  getRecord(path, id, params = {}) {
    return axios.get(`${path}/${id}`, { params }).then((response) => {
      return response.data;
    });
  },

  makePostRequest(path, params = {}) {
    return axios.post(path, params).then((response) => {
      return response;
    });
  },

  makePutRequest(path, params = {}) {
    return axios.put(path, params).then((response) => {
      return response;
    });
  },

  makePatchRequest(path, params = {}) {
    return axios.patch(path, params).then((response) => {
      return response;
    });
  },

  deleteRecord(path, id) {
    return axios.delete(`${path}/${id}`).then((response) => {
      return response.data.data;
    });
  },

  deleteRecords(path, params = {}) {
    return axios.delete(path, { data: params }).then((response) => {
      return response;
    });
  },

  uploadFile(path, params = {}) {
    const formData = new FormData();
    const keys = Object.keys(params);
    let i;

    // Require file and enforce 2mb limit size
    if (!params.file || params.file.size > 2000000) {
      return new Promise((resolve) => {
        resolve({
          success: false,
        });
      });
    }

    for (i = 0; i < keys.length; i += 1) {
      formData.append(keys[i], params[keys[i]]);
    }

    return axios
      .post(path, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((response) => {
        return {
          success: false,
          status: response.response.status,
          data: [
            'Error uploading file, ensure the format is valid and try again.',
            `Error message: ${response.response.data.message}`,
          ],
        };
      });
  },

  downloadCSV(path, params = {}, filename = 'file.csv') {
    return axios({
      url: path,
      params,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      let fileUrl;
      let fileLink;

      if (response.data.type !== 'text/csv') {
        return false;
      }

      fileUrl = window.URL.createObjectURL(new Blob([response.data]));
      fileLink = document.createElement('a');
      fileLink.href = fileUrl;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  },
};
